import { Component, HostListener, ViewContainerRef, Input, Output, EventEmitter, AfterViewInit } from "@angular/core";
import { AlertService } from "@shared/alert/alert.service";

@Component({
  selector: "ipc-alert",
  templateUrl: "./alert.component.html",
  styleUrls: ["./alert.component.scss"],
})
export class AlertComponent implements AfterViewInit {
  @Input() message: string;
  @Input() type: AlertType;
  @Input() lifeSpan: number;
  @Input() autoClose: boolean;
  @Input() ctaMessage: string;
  @Output() onMouseEnter: EventEmitter<any> = new EventEmitter<any>();
  @Output() onMouseLeave: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAlertClick: EventEmitter<any> = new EventEmitter<any>();

  private timer: any;

  constructor(private viewContainerRef: ViewContainerRef,
              private alertService: AlertService) {
    this.autoClose = true;
    this.lifeSpan = 5000;
  }

  ngAfterViewInit(): void {
    this.mouseLeave();
  }

  @HostListener("document.keydown.escape", ["$event"])
  public keyboardInput(event: KeyboardEvent) {
    this.destroyComponent();
  }

  @HostListener("mouseenter")
  public mouseEnter() {
    if (this.autoClose) {
      this.stopTimer();
    }
    this.onMouseEnter.emit();
  }

  @HostListener("mouseleave")
  public mouseLeave() {
    if (this.autoClose) {
      this.startTimer(this.getLifeSpan(this.message));
    }
    this.onMouseLeave.emit();
  }

  public click() {
    this.onAlertClick.emit();
  }

  private startTimer(miliseconds: number) {
    this.timer = setTimeout(() => {
      this.destroyComponent();
    }, miliseconds);
  }

  private stopTimer() {
    this.alertService.removeAlertFromQueue();
    if (this.timer != undefined) {
      clearTimeout(this.timer);
    }
  }

  private getLifeSpan(words: string): number {
    const duration = words.length * 50;

    if (duration < this.lifeSpan) {
      return this.lifeSpan;
    } else {
      return duration;
    }
  }

  private destroyComponent() {
    this.alertService.removeAlertFromQueue();
    this.viewContainerRef.element.nativeElement.parentElement.removeChild(this.viewContainerRef.element.nativeElement);
  }
}

export enum AlertType {
  Success = "success",
  Error = "error",
  Warning = "warning",
  Info = "info",
}
